import {Component, Host, h, Prop} from '@stencil/core';

@Component({
  tag: 'securecall-response-field',
  styleUrl: 'securecall-response-field.css',
  shadow: true,
})
export class SecurecallResponseField {
  @Prop() fieldName: string;
  @Prop() label: string;
  @Prop() value: string;

  render() {
    return (
      <Host>
        <div class="field-container">
          <label class="custom-label" htmlFor={this.fieldName}>
            {this.label}:
          </label>
          <div
            class="response-field"
            id={this.fieldName}
          >{this.value}</div>
        </div>
      </Host>
    );
  }
}
